// components/LanguageSwitcher.jsx
import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { motion, AnimatePresence } from 'framer-motion';
import ReactCountryFlag from 'react-country-flag';

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const languages = [
        { code: 'en', name: 'English', countryCode: 'IN' },
        // { code: 'hi', name: 'Indian', countryCode: 'IN' },
        { code: 'ms', name: 'Malaysian', countryCode: 'MY' }
    ];

    const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

    const changeLanguage = (langCode) => {
        i18n.changeLanguage(langCode);
        setIsOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="relative" ref={dropdownRef}>
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center gap-2 px-3 py-2 rounded-lg bg-white/5 hover:bg-white/10 transition-all border border-white/10"
            >
                <ReactCountryFlag
                    countryCode={currentLanguage.countryCode}
                    svg
                    style={{
                        width: '24px',
                        height: '18px',
                        borderRadius: '2px',
                        objectFit: 'cover'
                    }}
                />
                <span className="text-white font-medium text-sm hidden sm:block">
                    {currentLanguage.code.toUpperCase()}
                </span>
                <svg 
                    className={`w-4 h-4 text-white transition-transform ${isOpen ? 'rotate-180' : ''}`}
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
            </button>

            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ opacity: 0, y: -10, scale: 0.95 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: -10, scale: 0.95 }}
                        transition={{ duration: 0.15 }}
                        className="absolute top-full mt-2 right-0 min-w-[180px] bg-darker/95 backdrop-blur-xl rounded-xl shadow-2xl border border-white/10 overflow-hidden z-50"
                    >
                        <div className="py-1">
                            {languages.map((lang) => (
                                <button
                                    key={lang.code}
                                    onClick={() => changeLanguage(lang.code)}
                                    className={`w-full flex items-center gap-3 px-4 py-2.5 transition-colors ${
                                        i18n.language === lang.code
                                            ? 'bg-primary/20 text-primary'
                                            : 'text-gray-300 hover:bg-white/5 hover:text-white'
                                    }`}
                                >
                                    <ReactCountryFlag
                                        countryCode={lang.countryCode}
                                        svg
                                        style={{
                                            width: '24px',
                                            height: '18px',
                                            borderRadius: '2px',
                                            objectFit: 'cover'
                                        }}
                                    />
                                    <span className="font-medium">{lang.name}</span>
                                    {i18n.language === lang.code && (
                                        <svg className="w-4 h-4 ml-auto" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                        </svg>
                                    )}
                                </button>
                            ))}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default LanguageSwitcher;








// import React, { useState } from 'react';
// import { useTranslation } from 'react-i18next';
// import { motion, AnimatePresence } from 'framer-motion';

// const languages = [
//   { code: 'en', name: 'English', flag: '🇬🇧' },
//   { code: 'hi', name: 'हिन्दी', flag: '🇮🇳' },
//   { code: 'zh', name: '中文', flag: '🇨🇳' },
// ];

// export default function LanguageSwitcher() {
//   const { i18n } = useTranslation();
//   const [isOpen, setIsOpen] = useState(false);

//   const currentLang = languages.find(l => l.code === i18n.language) || languages[0];

//   const changeLanguage = (code) => {
//     i18n.changeLanguage(code);
//     localStorage.setItem('betmaster_lang', code);
//     setIsOpen(false);
//   };

//   return (
//     <div className="relative">
//       <button
//         onClick={() => setIsOpen(!isOpen)}
//         className="flex items-center gap-2 px-3 py-2 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 transition-all text-white"
//       >
//         <span>{currentLang.flag}</span>
//         <span className="text-sm font-medium hidden sm:inline">{currentLang.code.toUpperCase()}</span>
//       </button>

//       <AnimatePresence>
//         {isOpen && (
//           <motion.div
//             initial={{ opacity: 0, y: 10, scale: 0.95 }}
//             animate={{ opacity: 1, y: 0, scale: 1 }}
//             exit={{ opacity: 0, y: 10, scale: 0.95 }}
//             className="absolute right-0 mt-2 w-40 bg-card/95 backdrop-blur-sm border border-white/10 rounded-xl overflow-hidden shadow-xl z-50"
//           >
//             {languages.map((lang) => (
//               <button
//                 key={lang.code}
//                 onClick={() => changeLanguage(lang.code)}
//                 className={`w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-white/10 transition-all ${
//                   i18n.language === lang.code ? 'bg-primary/20 text-primary' : 'text-white'
//                 }`}
//               >
//                 <span className="text-lg">{lang.flag}</span>
//                 <span className="text-sm font-medium">{lang.name}</span>
//                 {i18n.language === lang.code && (
//                   <span className="ml-auto text-primary">✓</span>
//                 )}
//               </button>
//             ))}
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </div>
//   );
// }